import Image from 'next/image';
import React from 'react';
import { styled } from 'styled-components';
import { AuthorProps } from '../../types/pages/author';
import Link from 'next/link';

export default function AuthorInfoCard({ authorData }: AuthorProps) {
  const SeparatorLine = styled.div`
    height: 1px;
    background: rgba(221, 221, 221, 1);
    border: 1px rgba(221, 221, 221, 1);
  `;
  const socialIcons = [
    {
      iconSrc: '/facebook-circled-icon.svg'
    },
    {
      iconSrc: '/instagram-circled-icon.svg'
    },
    {
      iconSrc: '/linkedin-circled-icon.svg'
    },
    {
      iconSrc: '/twitter-circled-icon.svg'
    }
  ];

  return (
    <div className="border border-[#E0E0E0] py-10 rounded-[20px] h-auto lg:h-[488px] p-10 w-full lg:w-[344px]">
      <div className="flex flex-col">
        <div className="flex flex-col gap-7">
          <Image
            src={authorData?.image ?? '/default-profile-icon.svg'}
            alt="author-pic"
            width={200}
            height={100}
            className="self-center object-cover w-[200px] h-[200px] rounded-full  border-[#DDDDDD] border-[2px]"
          />
          <div className="flex flex-col text-center">
            <h1 className="font-semibold text-xl lg:text-2xl text-black13">
              {authorData.name}
            </h1>
            <p className="text-sm lg:text-[15px] text-[#777] font-medium leading-normal">
              Travel Writer
            </p>
          </div>
        </div>
        <SeparatorLine className="mt-[20px] mb-[50px]" />

        <div className="flex flex-row gap-5 justify-center">
          {authorData?.social_links?.social_links?.map((icon: any) => (
            <Link href={icon.link} target="_blank" key={icon.link}>
              <Image
                src={
                  icon.name.toLowerCase().includes('facebook')
                    ? socialIcons[0].iconSrc
                    : icon.name.toLowerCase().includes('instagram')
                    ? socialIcons[1].iconSrc
                    : icon.name.toLowerCase().includes('linkedin')
                    ? socialIcons[2].iconSrc
                    : socialIcons[3].iconSrc
                }
                alt={icon.name}
                width={36}
                height={36}
                className="cursor-pointer"
              />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
